
export const getIconStatus = (status, type) => {
    const defaultIcon = `/static/iconSvg/cars/car_lost_gsm.svg`
    const iconMapping = {
        'Xe ô tô con': {
            lost_gps: '/static/iconSvg/cars/car_lost_gps.svg',
            lost_gms: '/static/iconSvg/cars/car_lost_gsm.svg',
            stopped: '/static/iconSvg/cars/car_stopped.svg',
            moving: '/static/iconSvg/cars/car_moving.svg',
            over_speed: '/static/iconSvg/cars/car_out_speed.svg',
        },
        'Xe khách': {
            lost_gps: '/static/iconSvg/coach/coach_lost_gps.svg',
            lost_gms: '/static/iconSvg/coach/coach_lost_gsm.svg',
            stopped: '/static/iconSvg/coach/coach_stopped.svg',
            moving: '/static/iconSvg/coach/coach_moving.svg',
            over_speed: '/static/iconSvg/coach/coach_out_speed.svg',
        },
        'Xe tải': {
            lost_gps: '/static/iconSvg/trucks/truck_lost_gps.svg',
            lost_gms: '/static/iconSvg/trucks/truck_lost_gsm.svg',
            stopped: '/static/iconSvg/trucks/truck_stopped.svg',
            moving: '/static/iconSvg/trucks/truck_moving.svg',
            over_speed: '/static/iconSvg/trucks/truck_out_speed.svg',
        },
        'Xe bồn': {
            lost_gps: '/static/iconSvg/tankTrucks/tankTruck_lost_gps.svg',
            lost_gms: '/static/iconSvg/tankTrucks/tankTruck_lost_gsm.svg',
            stopped: '/static/iconSvg/tankTrucks/tankTruck_stopped.svg',
            moving: '/static/iconSvg/tankTrucks/tankTruck_moving.svg',
            over_speed: '/static/iconSvg/tankTrucks/tankTruck_out_speed.svg',
        },
        'Thuyền': {
            lost_gps: '/static/iconSvg/boats/boat_lost_gps.svg',
            lost_gms: '/static/iconSvg/boats/boat_lost_gsm.svg',
            stopped: '/static/iconSvg/boats/boat_stopped.svg',
            moving: '/static/iconSvg/boats/boat_moving.svg',
            over_speed: '/static/iconSvg/boats/boat_out_speed.svg',
        },
        'Tàu hỏa': {
            lost_gps: '/static/iconSvg/trains/train_lost_gps.svg',
            lost_gms: '/static/iconSvg/trains/train_lost_gsm.svg',
            stopped: '/static/iconSvg/trains/train_stopped.svg',
            moving: '/static/iconSvg/trains/train_moving.svg',
            over_speed: '/static/iconSvg/trains/train_out_speed.svg',
        },
        'Xe Container': {
            lost_gps: '/static/iconSvg/container/container_lost_gps.svg',
            lost_gms: '/static/iconSvg/container/container_lost_gsm.svg',
            stopped: '/static/iconSvg/container/container_stopped.svg',
            moving: '/static/iconSvg/container/container_moving.svg',
            over_speed: '/static/iconSvg/container/container_out_speed.svg',
        },
        'Xe máy': {
            lost_gps: '/static/iconSvg/motors/motor_lost_gps.svg',
            lost_gms: '/static/iconSvg/motors/motor_lost_gsm.svg',
            stopped: '/static/iconSvg/motors/motor_stopped.svg',
            moving: '/static/iconSvg/motors/motor_moving.svg',
            over_speed: '/static/iconSvg/motors/motor_out_speed.svg',
        },
        'Con người': {
            lost_gps: '/static/iconSvg/human/human_lost_gps.svg',
            lost_gms: '/static/iconSvg/human/human_lost_gsm.svg',
            stopped: '/static/iconSvg/human/human_stopped.svg',
            moving: '/static/iconSvg/human/human_moving.svg',
            over_speed: '/static/iconSvg/human/human_out_speed.svg',
        }
        
    };
    const defaultTypeMapping = {
        lost_gps: '/static/iconSvg/cars/car_lost_gps.svg',
        lost_gms: '/static/iconSvg/cars/car_lost_gsm.svg',
        stopped: '/static/iconSvg/cars/car_stopped.svg',
        moving: '/static/iconSvg/cars/car_moving.svg',
        over_speed: '/static/iconSvg/cars/car_out_speed.svg',
    };
    return iconMapping[type]?.[status] || defaultTypeMapping[status] || defaultIcon;
};

export const vehicleStates = [
    {
      list: 'lost_gsm_vehicles',
      id: 1
    },
    {
      list: 'over_speed_vehicles',
      id: 2
    },
    {
      list: 'stop_vehicles',
      id: 3
    },
    {
      list: 'running_vehicles',
      id: 4
    },
    {
      list: 'lost_gps_vehicles',
      id: 5
    }
  ];
